import { useMantineColorScheme, useComputedColorScheme } from "@mantine/core";

/**
 * Shared light/dark toggle state.
 *
 * Two surfaces drive the same switch: the header's `ColorSchemeToggle` icon,
 * and the launcher-menu entry that stands in for it below `md` (where the 11"
 * iPad portrait header has no room for the icon). They must never disagree
 * about the current scheme or the wording, so both read from here.
 *
 * `useComputedColorScheme` — not `colorScheme` — is what resolves "auto" to
 * the scheme actually on screen; reading `colorScheme` would leave the label
 * saying "Switch to dark mode" while the UI is already dark.
 */
export function useColorSchemeToggle() {
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme("light");
  const next = computed === "dark" ? "light" : "dark";

  return {
    computed,
    next,
    label: `Switch to ${next} mode`,
    toggle: () => setColorScheme(next),
  };
}
